
import App from './App';
import Home from './pages/Home';
import Contacto from './pages/Contacto';
import { createHashRouter, Navigate, RouterProvider } from 'react-router-dom';

const Navigation = () => {

    const routers = createHashRouter([
        {
            element: <App/>,
            children: [
                {
                    path: "/",
                    element: <Home />
                },
                {
                    path: "/contacto",
                    element: <Contacto />
                },
                {
                    path : "*",
                    element : <Navigate to="/" replace/>
                }
            ]
        }
    ]);

    return (
        <RouterProvider router={routers} />
    )
}


export default Navigation;